import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { VOICE_LIBRARY } from '@src/constants/voice';
import actions from '@src/redux/actions';
import { StyledVoiceFilter } from './index.styled';

const VoiceFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { filterVoice } = useSelector((state) => state.voice);
  const voiceOwnershipFilter = filterVoice?.voiceOwnership;

  const handleChangeVoiceOwnership = (value) =>
    dispatch(
      actions.voice.changeFilterVoice({
        ...filterVoice,
        voiceOwnership: value,
      }),
    );

  return (
    <StyledVoiceFilter>
      {VOICE_LIBRARY.map((item) => (
        <Button
          fullWidth
          className={`filter-button ${
            voiceOwnershipFilter === item.value ? 'active-button' : ''
          }`}
          onClick={() => handleChangeVoiceOwnership(item.value)}
          key={item.value}
        >
          {t(item.label)}
        </Button>
      ))}
    </StyledVoiceFilter>
  );
};

export default VoiceFilter;
